import { lazy, Suspense } from 'react';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';

// Every route is its own chunk: visiting a landing page downloads only that page's JS + CSS.
const Home = lazy(() => import(/* webpackChunkName: "home" */ './pages/Home'));
const QuaranStand = lazy(() => import(/* webpackChunkName: "quaran-stand" */ './landings/quaran-stand'));
const SavingsBox = lazy(() => import(/* webpackChunkName: "savings-box" */ './landings/savings-box'));

function NotFound() {
  return (
    <div style={{ padding: '80px 16px', textAlign: 'center' }}>
      <h1 style={{ margin: 0 }}>পেজটি পাওয়া যায়নি</h1>
      <p><Link to="/">হোম পেজে ফিরে যান</Link></p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/landing/quaran-stand" element={<QuaranStand />} />
          <Route path="/landing/savings-box" element={<SavingsBox />} />
          {/* old static-page URL — kept so existing ad and share links still work */}
          <Route path="/savings-box" element={<SavingsBox />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
